import React from 'react'
import { emiData } from '../../../../utils/JsonData/emipaymentdata'
import { Table, Typography , Button} from 'antd';
import { useEffect, useState } from 'react';
import { getEmipayments } from '../../../../api/EmiPayments';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../helper/CurrencyFormate';
import { TabsEnum } from '../../../../utils/Enum/ReportTabsEnum';
import { StarFilled } from "@ant-design/icons";

const EmiPayments = ({ onClickTabChange = () => { } }) => {

  const [emiData, setemitData] = useState(null);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

  const columns = [
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      width: 190,
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      width: 190,
    },
    {
      title: 'Particulars',
      dataIndex: 'particulars',
      key: 'particulars',
    },
    {
      title: 'Counterparty',
      dataIndex: 'counterparty',
      key: 'counterparty',
    },
    {
      title: `Amount (${CURRENCY})`,
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      className: 'no-wrap-column',
      render: (value) => (
        <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
    ),
    },
    {
      title: 'Txn Count',
      dataIndex: 'transactionCount',
      key: 'transactionCount',
      render: (value, record, index) => {
        return (parseFloat(value) > 0 ) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
    }
    },
    {
      title: 'Interval',
      dataIndex: 'interval',
      key: 'interval',
    },
    {
      title: 'Misses',
      dataIndex: 'misses',
      key: 'misses',
    },
  ];

  if(selectedAccountId === "all"){
    columns.unshift({
      title: "Bank Account",
      dataIndex: "accountDetails",
      key: "accountDetails",
      width: 190,
      render: value => (
        <>
        <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
        {`${value?.bankAbbreviation} - ${value?.accountNumber.slice(8,12)} - ${value?.accountType}`}
        </>
      )
    })
  }

  useEffect(() => {

    const fetchData = async () => {
      try {
        let aggregate = selectedAccountId !== 'all'? false : true;
        let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
        const response = await getEmipayments(account_id, aggregate, "emi");

        setemitData(response.emi);

      } catch (error) {

        console.log("ERROR", error);
      }
    }

    if (selectedAccountId) {
      fetchData();
    }
  }, [selectedAccountId]);

  return (
    <Table
      columns={columns}
      dataSource={emiData}
      pagination={{ pageSize: 100 }}
      scroll={{ x: true }}
    />
  )
}

export default EmiPayments